import React, { useState } from 'react'
import axios from 'axios'
import { Link } from 'gatsby'
import FormSuccessBox from '../FormSuccessBox/FormSuccessBox'
import HelpLabel from '../HelpLabel/LoadableHelpLabel'
import FormErrors from '../FormErrors/FormErrors'
import { useForm } from 'react-hook-form'


const OrderForm = ({ successText }) => {

	//const [organization, setOrganization] = useState('')
	const [formSettings, setFormSettings] = useState({
		sent: false,
		loading: false,
		dialogOpen: false,
		formSuccessBoxText: successText
	})

	const { register, handleSubmit, watch, formState:{errors}, setValue } = useForm({
		mode: 'onChange',
		reValidate: 'onChange',
		defaultValues: {
			karnovSameInvoice: 'karnovSameInvoice'
		}
	})

	const watchInvoiceType = watch('invoiceType')
	const watchUsers = watch('users')
	const watchKarnov = watch('karnov')
	const watchKarnovSameInvoice = watch('karnovSameInvoice')
	const watchKarnovInvoiceType = watch('karnovInvoiceType')

	const searchCompany = e => {
		let orgNr = e.target.value.replace(/\s/g, '');
		setValue('orgNumber', orgNr)
		if (Math.floor(Math.log10(parseInt(orgNr + 1))) === 9) {
			fetch(`https://data.brreg.no/enhetsregisteret/api/enheter/${orgNr}`)
				.then(response => response.json())
				.then(response => {
					if (response) {
						if(response.navn) {
							setValue('companyName', response.navn, { shouldValidate: true })
						}
					}
				})
				.catch(error => {
					console.log(error)
				})
		}
	}


	const closeModal = () => {
		setFormSettings({ ...formSettings, dialogOpen: !formSettings.dialogOpen })
	}

	const onSubmit = async data => {
		setFormSettings({ ...formSettings, loading: true })
		try {
			axios({
				method: 'post',
				url: '/.netlify/functions/mail-order',
				data: data
			})
				.then(response => {
					setFormSettings({ ...formSettings, loading: false })
					if (response.data.status === 'ok') {
						mailSent(response.data);
					} else {
						mailError(response.data.message, response.data);
					}
				})

		} catch (err) {
			setFormSettings({ ...formSettings, loading: false })
			mailError(err)
		}
	}

	const mailSent = data => {
		if (process.env.NODE_ENV === 'development') {
			console.log(data)
		}
		setFormSettings({ ...formSettings, dialogOpen: true, sent: true, formSuccessBoxText: successText })
	}

	const mailError = (message, log) => {
		console.log(log)
		setFormSettings({ ...formSettings, dialogOpen: true, sent: false, formSuccessBoxText: `<p>${message}</p>` })
	}

	return (
		<div className="OrderForm">
			<FormSuccessBox text={formSettings.formSuccessBoxText} close={closeModal} visible={formSettings.dialogOpen} />
			{
				process.env.NODE_ENV === 'development' &&
				<>
					<button onClick={closeModal}>Toggle modal</button>
					<p>Jukse Orgnr: 818343752</p>
				</>
			}
			{
				Object.keys(errors).length > 0 &&
				<FormErrors errors={errors} />
			}
			<form className="register-form" onSubmit={handleSubmit(onSubmit)}>
				<h2 className="seperator">Firmaopplysninger</h2>

				<div className={errors.orgNumber ? 'error field' : 'field'}>
					{errors.orgNumber && <p className="errorMessage">{errors.orgNumber.message}</p>}
					<label htmlFor="orgNumber">Organisasjonsnummer <small>(9 siffer)</small></label>
					<input
						type="text"
						{...register('orgNumber', {
							required: "Du må fylle inn organisasjonsnummeret ditt",
							minLength: {
								value: 9,
								message: "Organisasjonsnummeret må være 9 siffer"
							},
							pattern: {
								value: /^[0-9]*$/,
								message: "Organisasjonsnummer må kun være siffer uten mellomrom"
							}
						})}
						id="orgNumber"
						onChange={searchCompany}
						/>
				</div>

				<div className={errors.companyName ? 'error field' : 'field'}>
					{errors.companyName && <p className="errorMessage">{errors.companyName.message}</p>}
					<label htmlFor="companyName">Firmanavn{/*<small>(hentes automatisk)</small>*/}</label>
					<input
						type="text"
						{...register('companyName', { required: 'Finner ikke gyldig firmanavn' })}
						id="companyName"
						//value={organization}
						//placeholder="Firmanavn hentes automatisk"
						//readOnly
						/>
				</div>

				<div className={errors.address ? 'error field' : 'field'}>
					{errors.address && <p className="errorMessage">{errors.address.message}</p>}
					<label htmlFor="address">Postadresse</label>
					<input
						type="text"
						{...register('address', {
							required: "Du må fylle inn Postadresse",
							minLength: {
								value: 5,
								message: "Adressen er for kort"
							}
						})}
						id="address"
						autoComplete="street-address" />
				</div>

				<div className={errors.postalCode ? 'error field' : 'field'}>
					{errors.postalCode && <p className="errorMessage">{errors.postalCode.message}</p>}
					<label htmlFor="postalCode">Postnummer</label>
					<input
						type="text"
						{...register('postalCode', {
							required: "Du må fylle inn postnunmmeret",
							minLength: {
								value: 4,
								message: "Postnummeret er for kort, det må være 4 siffer"
							},
							maxLength: {
								value: 4,
								message: "Postnummeret er for langt, det må være 4 siffer"
							},
							pattern: {
								value: /^[0-9]*$/,
								message: "Postnummer må kun være siffer"
							}
						})}
						id="postalCode"
						autoComplete="postal-code" />
				</div>

				<div className={errors.city ? 'error field' : 'field'}>
					{errors.city && <p className="errorMessage">{errors.city.message}</p>}
					<label htmlFor="city">Poststed</label>
					<input
						type="text"
						{...register('city', {
							required: "Du må fylle inn poststed",
						})}
						id="city"
						autoComplete="address-level2" />
				</div>

				<div className="field">
					<label htmlFor="phone">Telefonnummer</label>
					<input type="tel" {...register('phone')} id="phone" autoComplete="tel" />
				</div>

				<h2 className="seperator">Brukere</h2>
				<div className={errors.users ? 'error field' : 'field'}>
					{errors.users && <p className="errorMessage">{errors.users.message}</p>}
					<label className="help-label" htmlFor="users">
						Velg antall brukere
						<HelpLabel title="Antall brukere" text="Her oppgir du hvor mange personlige brukere som du tror vil bli opprettet under Deres abonnement. For advokatkontorer oppgis antall jurister i virksomheten." />
					</label>
					<select id="users" {...register('users')}>
						<option value="3">1 - 3 brukere</option>
						<option value="6">4 - 6 brukere</option>
						<option value="10">7 - 10 brukere</option>
						<option value="15">11 - 15 brukere</option>
						<option value="20">16 - 20 brukere</option>
						<option value="30">21 - 30 brukere</option>
						<option value="Bibliotek">Folke- og fylkesbibliotek</option>
					</select>
				</div>

				{
					watchUsers === 'Bibliotek' &&
					<div>

						<div className={errors.libraryName ? 'error field' : 'field'}>
							{errors.libraryName && <p className="errorMessage">{errors.libraryName.message}</p>}
							<label htmlFor="libraryName">Biblioteksnavn</label>
							<input
								type="text"
								{...register('libraryName', {
									required: "Du må fylle inn navnet på Biblioteket",
									minLength: {
										value: 5,
										message: "Navnet er for kort"
									}
								})}
								id="libraryName" />
						</div>

						<div className={errors.ips ? 'error field' : 'field'}>
							{errors.ips && <p className="errorMessage">{errors.ips.message}</p>}
							<label htmlFor="ips">IP-adresser</label>
							<textarea
								{...register('ips', {
									required: "Du må fylle inn IP-adresser",
								})}
								id="ips" />
						</div>


					</div>
				}

				<div className="field">
					<label htmlFor="comments">Kommentarer</label>
					<textarea {...register('comments')} id="comments" />
				</div>

				<h2 className="seperator">
					Karnov Lovkommentarer
				</h2>

				<div>
					<div className="form-checkbox field">
						<label htmlFor="karnov">
							<input
								type="checkbox"
								value="karnov-kommentarer"
								{...register('karnov')}
								id="karnov" />
							<span className="box" />
							Bestill med <Link to="/karnov-lovkommentarer">Karnov Lovkommentarer</Link>
							<HelpLabel title="" text="Ved å krysse av her bestiller du Karnov Lovkommentarer som en tilleggstjeneste sammen med bestillingen av Lovdata Pro. Karnov Lovkommentarer leveres av Karnov. Lovdata videreformidler din bestilling og avtale blir satt opp mellom kunden og Karnov direkte." />
						</label>
					</div>
				</div>

				{
					watchKarnov &&
					<div>
						<div className="form-checkbox field">
							<label htmlFor="karnovSameInvoice">
								<input
									defaultChecked={true}
									type="checkbox"
									value="karnovSameInvoice"
									{...register('karnovSameInvoice')}
									id="karnovSameInvoice" />
								<span className="box" />
								Bestill med samme fakturainformasjon som for Lovdata Pro
								<HelpLabel title="" text="Ved å krysse bort her får du anledning til å definere egen fakturaopplysning for Karnov Lovkommentarer. Vi videreformidler opplysningene til Karnov." />
							</label>
						</div>
					</div>
				}

				{
					watchKarnov && !watchKarnovSameInvoice &&
					<div>
						<h2 className="seperator">Karnov fakturainformasjon</h2>

						<fieldset className={errors.karnovInvoiceType ? 'inline field error' : 'inline field'}>
							{errors.karnovInvoiceType && <p className="errorMessage">{errors.karnovInvoiceType.message}</p>}
							<div className="form-radio">
								<label htmlFor="karnovInvoiceEhf">
									<input
										type="radio"
										value="ehf"
										{...register('karnovInvoiceType', {
											required: 'Du må velge fakturatype'
										})}
										id="karnovInvoiceEhf" />
									<span className="box" />
									Faktura på EHF
								</label>
							</div>

							<div className="form-radio">
								<label htmlFor="karnovInvoiceEmail">
									<input
										type="radio"
										value="email"
										{...register('karnovInvoiceType', {
											required: 'Du må velge fakturatype'
										})}
										id="karnovInvoiceEmail" />
									<span className="box" />
									Faktura på E-post
								</label>
							</div>
						</fieldset>

						<div className="field">
							<label className="help-label" htmlFor="karnovInvoiceReference">
								Karnov fakturareferanse
								<HelpLabel title="" text="Dersom du ønsker fakturaen merket med et navn, en referanse eller en kode kan du legge inn dette her." />
							</label>
							<input
								type="text"
								{...register('karnovInvoiceReference')}
								id="karnovInvoiceReference" />
						</div>

						{
							watchKarnovInvoiceType === 'email' &&
							<div className={errors.karnovInvoiceEmail ? 'error field' : 'field'}>
								{errors.karnovInvoiceEmail && <p className="errorMessage">{errors.karnovInvoiceEmail.message}</p>}
								<label className="help-label" htmlFor="karnovInvoiceEmail">
									Karnov faktura E-postadresse
									<HelpLabel title="" text="Fakturaen bør sendes til e-postadresse som benyttes av virksomheten til fakturamottak og helst ikke personlig e-postadresse." />
								</label>
								<input
									type="email"
									{...register('karnovInvoiceEmail', {
										required: "Du må fylle inn faktura E-postadresse",
										pattern: {
											value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
											message: "Ugyldig epostadresse"
										}
									})}
									id="karnovInvoiceEmail"
									autoComplete="email" />
							</div>
						}

					</div>
				}

				{
					watchKarnov &&
					<div>
						<div className="form-checkbox field">
							{errors.karnovTermsCheckbox && <p className="errorMessage">{errors.karnovTermsCheckbox.message}</p>}
							<label htmlFor="karnovTermsCheckbox">
								<input
									id="karnovTermsCheckbox"
									type="checkbox"
									{...register(
										'karnovTermsCheckbox',
										{ required: 'Du må akseptere avtalevilkårene før du sender inn bestilling' },
									)} />
								<span className="box" />
								Jeg har lest og akseptert <a target="_blank" rel="noreferrer" href="//www.karnovgroup.no/abonnementsavtale">avtalevilkårene</a> for Karnov Lovkommentarer
							</label>
						</div>
					</div>
				}



				{
					watchUsers !== 'Bibliotek' &&
					<div>
						<h2 className="seperator">Faktura</h2>
						<fieldset className={errors.invoiceType ? 'inline field error' : 'inline field'}>
							{errors.invoiceType && <p className="errorMessage">{errors.invoiceType.message}</p>}
							<div className="form-radio">
								<label htmlFor="invoice-ehf">
									<input
										type="radio"
										value="EHF"
										{...register('invoiceType', {
											required: 'Du må velge fakturatype'
										})}
										id="invoice-ehf" />
									<span className="box" />
									Faktura på EHF
								</label>
							</div>

							<div className="form-radio">
								<label htmlFor="invoice-email">
									<input
										type="radio"
										value="E-post"
										{...register('invoiceType', {
											required: 'Du må velge fakturatype'
										})}
										id="invoice-email" />
									<span className="box" />
									Faktura på E-post
								</label>
							</div>
						</fieldset>

						{
							watchInvoiceType === 'E-post' &&
							<div className={errors.invoiceEmail ? 'error field' : 'field'}>
								{errors.invoiceEmail && <p className="errorMessage">{errors.invoiceEmail.message}</p>}
								<label className="help-label" htmlFor="invoiceEmail">
									Faktura E-postadresse
									<HelpLabel title="" text="Fakturaen bør sendes til e-postadresse som benyttes av virksomheten til fakturamottak og helst ikke personlig e-postadresse." />
								</label>
								<input
									type="email"
									{...register('invoiceEmail', {
										required: "Du må fylle inn faktura E-postadresse",
										pattern: {
											value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
											message: "Ugyldig epostadresse"
										}
									})}
									id="invoiceEmail"
									autoComplete="email" />
							</div>
						}

						<div className="field">
							<label className="help-label" htmlFor="invoiceReference">
								Fakturareferanse
								<HelpLabel title="" text="Dersom du ønsker fakturaen merket med et navn, en referanse eller en kode kan du legge inn dette her." />
							</label>
							<input type="text" {...register('invoiceReference')} id="invoiceReference" />
						</div>
					</div>
				}

				<h2 className="seperator">Kontaktinformasjon</h2>
				<div className={errors.contactPersonName ? 'error field' : 'field'}>
					{errors.contactPersonName && <p className="errorMessage">{errors.contactPersonName.message}</p>}
					<label htmlFor="contactPersonName">Fornavn</label>
					<input
						type="text"
						{...register('contactPersonName', { required: 'Du må fylle ut fornavn' })}
						id="contactPersonName"
						autoComplete="given-name" />
				</div>

				<div className={errors.contactPersonSurname ? 'error field' : 'field'}>
					{errors.contactPersonSurname && <p className="errorMessage">{errors.contactPersonSurname.message}</p>}
					<label htmlFor="contactPersonSurname">Etternavn</label>
					<input
						type="text"
						{...register('contactPersonSurname', { required: 'Du må fylle ut etternavn' })}
						id="contactPersonSurname"
						autoComplete="family-name" />
				</div>

				<div className={errors.contactPersonPhone ? 'error field' : 'field'}>
					{errors.contactPersonPhone && <p className="errorMessage">{errors.contactPersonPhone.message}</p>}
					<label htmlFor="contactPersonPhone">Telefonnummer</label>
					<input
						type="tel"
						{...register('contactPersonPhone', {
							required: "Du må fylle inn telefonnummeret ditt",
							minLength: {
								value: 8,
								message: "Telefonnummeret er for kort, det må være minst 8 siffer"
							},
							maxLength: {
								value: 15,
								message: "Telefonnummeret er for langt, det må være maks 15 siffer"
							},
							pattern: {
								value: /^[0-9]*$/,
								message: "Telefonnummer må kun være siffer"
							}
						})}
						id="contactPersonPhone"
						autoComplete="tel" />
				</div>

				<div className={errors.contactPersonEmail ? 'error field' : 'field'}>
					{errors.contactPersonEmail && <p className="errorMessage">{errors.contactPersonEmail.message}</p>}
					<label htmlFor="contactPersonEmail">Epost</label>
					<input
						type="email"
						{...register('contactPersonEmail', {
							required: "Du må fylle inn eposten din",
							pattern: {
								value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
								message: "Ugyldig epostadresse"
							}
						})}
						id="contactPersonEmail"
						autoComplete="email" />
				</div>

				<br />
				<div className="field">
					<label htmlFor="discount">Rabattkode</label>
					<input type="text" {...register('discount')} id="discount" />
				</div>
				<br />
				<div>
					<div className="form-checkbox field">
						{errors.termsCheckbox && <p className="errorMessage">{errors.termsCheckbox.message}</p>}
						<label htmlFor="termsCheckbox">
							<input
								id="termsCheckbox"
								type="checkbox"
								{...register(
									'termsCheckbox',
									{ required: 'Du må akseptere avtalevilkårene før du sender inn bestilling' },
								)} />
							<span className="box" />
							Jeg har lest og akseptert <a target="_blank" href="/abonnentsavtale">avtalevilkårene</a>
						</label>
					</div>
				</div>

				<button type="submit" disabled={formSettings.sent} className={`Button blue_dark loader ${formSettings.loading ? 'loading' : ''}`}><span>Send inn</span></button>
			</form>
		</div>
	);
}

export default OrderForm